<template>
  <dialog ref="dialog" class="service-status-dialog" aria-labelledby="service-status-title" @cancel.prevent="close">
    <div class="service-status-content">
      <h2 id="service-status-title">{{ active ? 'غیرفعال‌کردن خدمت' : 'فعال‌کردن خدمت' }}</h2>
      <strong>{{ service.verbose_name || service.title }}</strong>
      <p>{{ active ? 'این خدمت برای برنامه‌های جدید قابل انتخاب نخواهد بود. برنامه‌های موجود و پاسخ‌های تکنسین حفظ می‌شوند.' : 'پس از فعال‌سازی، این خدمت در ثبت برنامه برای تکنسین قابل انتخاب می‌شود.' }}</p>
      <p v-if="loading" role="status">در حال بررسی آخرین نسخه…</p>
      <p v-if="error" class="ea-error" role="alert">{{ error }}</p>
      <router-link v-if="!busy" :to="`/visitmanagment/visit-types/${service.id}/edit`" @click.native="close">مشاهده و ویرایش مراحل خدمت</router-link>
      <div class="ea-actions"><button type="button" :disabled="busy" @click="close">انصراف</button><button type="button" :class="active ? 'ea-danger' : 'ea-primary'" :disabled="loading || busy || !definition" @click="save">{{ busy ? 'در حال ثبت…' : active ? 'غیرفعال شود' : 'فعال شود' }}</button></div>
    </div>
  </dialog>
</template>
<script>
import { errorText, newKey } from '@/utils/executionAdmin';
export default {
  name: 'ServiceStatusDialog', props: { service: { type: Object, required: true } },
  data: () => ({ loading: true, busy: false, error: '', definition: null, requestKey: newKey() }),
  computed: { active() { return this.service.has_active_version || this.service.is_active; }, url() { return `/api/admin/service_templates/${this.service.id}/?p=${this.$STORE.state.userConfig.setProjectId}`; } },
  mounted() { this.$refs.dialog.showModal(); this.load(); },
  beforeDestroy() { if (this.$refs.dialog) this.$refs.dialog.close(); },
  methods: {
    close() { if (!this.busy) this.$emit('close'); },
    async load() {
      try { const r = await this.$ApiServiceLayer.get(this.url, this.$PATH.SERVICE_NAME.AUTH); if (r.status !== 200) throw new Error(errorText(this.$ApiServiceLayer, r)); this.definition = r.data; }
      catch (e) { this.error = e.message || 'دریافت وضعیت انجام نشد.'; } finally { this.loading = false; }
    },
    async save() {
      if (this.busy || !this.definition) return; this.busy = true; this.error = '';
      try {
        const r = await this.$ApiServiceLayer.put(this.url, this.$PATH.SERVICE_NAME.AUTH, { action: 'set_active', request_key: this.requestKey, expected_revision: this.definition.revision, is_active: !this.active });
        if (r.status !== 200) throw new Error(errorText(this.$ApiServiceLayer, r));
        this.$notify({ group: 'tc', type: 'success', text: this.active ? 'خدمت غیرفعال شد.' : 'خدمت فعال شد.' }); this.$emit('updated');
      } catch (e) { this.error = e.message || 'تغییر وضعیت انجام نشد.'; } finally { this.busy = false; }
    },
  },
};
</script>
